<template>
  <v-container fluid>
    <v-card class="pa-4">
      <!-- Header con botón Nuevo -->
      <div class="d-flex align-center mb-4">
        <v-icon color="#ce501b" size="large" class="mr-2">mdi-file-document-multiple</v-icon>
        <h2 class="text-h5">Plantillas</h2>
        <v-spacer></v-spacer>
        <v-btn
          color="#ce501b"
          prepend-icon="mdi-plus"
          @click="abrirModalNuevaPlantilla"
          elevation="2"
        >
          Nueva plantilla
        </v-btn>
        <v-btn
          icon
          @click="recargarDesdeInicio"
          :loading="loading && plantillas.length === 0"
          color="#ffe8e1"
          class="ml-2"
        >
          <v-icon color="#ce501b">mdi-refresh</v-icon>
        </v-btn>
      </div>

      <!-- Buscador -->
      <v-text-field
        ref="campoBusquedaRef"
        v-model="busqueda"
        prepend-inner-icon="mdi-magnify"
        label="Buscar plantilla..."
        variant="outlined"
        density="comfortable"
        clearable
        class="mb-4"
      ></v-text-field>

      <!-- Título de la tabla -->
      <div class="mb-2">
        <h3 class="text-subtitle-1 text-grey-darken-1">Listado Plantilla</h3>
      </div>

      <!-- Tabla con infinite scroll -->
      <div 
        class="plantillas-container" 
        @scroll="handleScroll"
        ref="scrollContainer"
      >
        <!-- Tabla -->
        <v-table class="plantillas-table" fixed-header>
          <thead>
            <tr>
              <th class="text-center" style="width: 150px;">Código</th>
              <th>Plantilla</th>
            </tr>
          </thead>
          <tbody>
            <tr 
              v-for="(plantilla, index) in plantillasFiltradas"
              :key="index"
              class="plantilla-row"
              @contextmenu.prevent="onContextMenuPlantilla($event, plantilla)"
            >
              <!-- Código -->
              <td class="text-center">
                <v-chip color="primary" size="small" label>
                  {{ plantilla.codigo }}
                </v-chip>
              </td>

              <!-- Plantilla -->
              <td>
                <div class="d-flex align-center">
                  <v-icon class="mr-2" size="small" color="blue-grey">mdi-file-document</v-icon>
                  <strong>{{ plantilla.plantilla }}</strong>
                </div>
              </td>
            </tr>
          </tbody>
        </v-table>

        <!-- Indicador de carga al final -->
        <div v-if="loading" class="text-center py-4">
          <v-progress-circular
            indeterminate
            color="primary"
            size="50"
          ></v-progress-circular>
          <p class="mt-2 text-caption">Cargando más plantillas...</p>
        </div>

        <!-- Mensaje cuando no hay más datos -->
        <div v-if="!loading && !hayMasDatos && plantillas.length > 0" class="text-center py-4 text-caption text-grey">
          <v-icon>mdi-check-circle</v-icon>
          No hay más plantillas para mostrar
        </div>

        <!-- Mensaje cuando no hay datos -->
        <div v-if="!loading && plantillas.length === 0" class="text-center py-8">
          <v-icon size="64" color="grey">mdi-file-document-outline</v-icon>
          <p class="text-h6 text-grey mt-2">No hay plantillas registradas</p>
        </div>
      </div>
    </v-card>

    <!-- ==================== MENÚ CONTEXTUAL PLANTILLAS ==================== -->
    <div
      v-if="menuContextual.visible"
      class="menu-contextual-custom"
      :style="{ left: menuContextual.x + 'px', top: menuContextual.y + 'px' }"
    >
      <div class="menu-item" @click="onModificarPlantilla">
        <v-icon size="small" color="primary" class="mr-2">mdi-pencil</v-icon>
        Modificar || Agregar campos
      </div>
      <div class="menu-item" @click="onEliminarPlantilla">
        <v-icon size="small" color="error" class="mr-2">mdi-close</v-icon>
        Eliminar
      </div>
    </div>

    <!-- ==================== MODAL NUEVA PLANTILLA ==================== -->
    <v-dialog v-model="dialogNuevaPlantilla" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h6 text-white" style="background-color: #004d82;">
          Agregar Plantilla
          <v-spacer></v-spacer>
          <v-btn icon @click="onCerrarModalNuevo" size="small" variant="text" color="white">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-form ref="formNuevaPlantilla"
           v-model="validFormNuevo"
           @submit.prevent="onGuardarPlantilla" 
           >
            <v-text-field
              ref="campoPlantillaRef"
              v-model="nuevaPlantilla.plantilla"
              label="Nombre plantilla"
              prepend-icon="mdi-file-document"
              variant="outlined"
              density="comfortable"
              :rules="[v => !!v || 'Nombre de plantilla es requerido']"
              class="mb-3 campo-amarillo"
          
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn type="button" color="#ce501b" variant="elevated" @click="onGuardarPlantilla" :loading="guardando" :disabled="!validFormNuevo">
            Guardar
          </v-btn>
          <v-btn type="button" color="#9B9B9B" variant="elevated" @click="onCerrarModalNuevo">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ==================== MODAL MODIFICAR PLANTILLA ==================== -->
    <v-dialog v-model="dialogModificarPlantilla" max-width="800px" persistent>
      <v-card>
        <v-card-title class="text-h6 text-white" style="background-color: #004d82;">
          Modificar Plantilla
          <v-spacer></v-spacer>
          <v-btn icon @click="onCerrarModalModificar" size="small" variant="text" color="white">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-form ref="formModificarPlantilla" v-model="validFormModificar" @submit.prevent="onGuardarModificacionPlantilla">
            <v-text-field
              v-model="plantillaSeleccionada.plantilla"
              label="Nombre plantilla"
              prepend-icon="mdi-file-document"
              variant="outlined"
              density="comfortable"
              :rules="[v => !!v || 'Nombre de plantilla es requerido']"
              class="mb-3 campo-amarillo"
            ></v-text-field>
          </v-form>

          <!-- Sección Listado Plantilla Detalle -->
          <div class="mt-4">
            <div class="d-flex align-center mb-2">
              <h3 class="text-subtitle-1 text-grey-darken-1">Listado de campos</h3>
              <v-spacer></v-spacer>
              <v-btn  variant="tonal" color="#ce501b" rounded="lg" size="small" prepend-icon="mdi-plus" @click="onAbrirModalNuevaColumna">
                Nuevo
              </v-btn>
            </div>

            <div class="detalle-container">
              <v-table class="detalle-table" density="compact" fixed-header>
                <thead>
                  <tr>
                    <th class="text-center" style="width: 60px;">#</th>
                    <th>Nombre campo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(columna, index) in columnasPlantilla"
                    :key="columna.codigo || index"
                    class="detalle-row"
                    :class="{ 'fila-seleccionada': columnaSeleccionadaIndex === index }"
                    @click="onSeleccionarColumna(index)"
                    @contextmenu.prevent="onContextMenuColumna($event, columna, index)"
                  >
                    <td class="text-center">{{ index + 1 }}</td>
                    <td>{{ columna.nombre_Campo }}</td>
                  </tr>
                </tbody>
              </v-table>

              <div v-if="columnasPlantilla.length === 0 && !cargandoColumnas" class="text-center py-4 text-grey">
                <v-icon>mdi-table-column</v-icon>
                <p class="text-caption mt-1">No hay columnas definidas</p>
              </div>

              <div v-if="cargandoColumnas" class="text-center py-4">
                <v-progress-circular indeterminate color="primary" size="30"></v-progress-circular>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn type="button" color="#ce501b" variant="elevated" @click="onGuardarModificacionPlantilla" :loading="guardandoModificacion" :disabled="!validFormModificar">
            Guardar
          </v-btn>
           <v-btn type="button" color="#9B9B9B" variant="elevated" @click="onCerrarModalModificar">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ==================== MENÚ CONTEXTUAL COLUMNAS ==================== -->
    <div
      v-if="menuColumna.visible"
      class="menu-contextual-custom"
      :style="{ left: menuColumna.x + 'px', top: menuColumna.y + 'px' }"
    >
      <div class="menu-item" @click="onModificarColumna">
        <v-icon size="small" color="primary" class="mr-2">mdi-pencil</v-icon>
        Modificar
      </div>
      <div class="menu-item" @click="onEliminarColumna">
        <v-icon size="small" color="error" class="mr-2">mdi-close</v-icon>
        Eliminar 
      </div>
    </div>

    <!-- ==================== MODAL AGREGAR COLUMNA (CON VALORES PREDETERMINADOS) ==================== -->
    <v-dialog v-model="dialogNuevaColumna" :max-width="nuevaColumna.valoresPredeterminados ? '750px' : '500px'" persistent>
      <v-card>
        <v-card-title class="text-h6 text-white" style="background-color: #004d82;">
          Agregar detalle plantilla
          <v-spacer></v-spacer>
          <v-btn icon @click="onCerrarModalNuevaColumna" size="small" variant="text" color="white">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-row>
            <!-- Columna izquierda: Formulario principal -->
            <v-col :cols="nuevaColumna.valoresPredeterminados ? 6 : 12">
              <v-form
               ref="formNuevaColumna"
               v-model="validFormNuevaColumna"
               @submit.prevent="onGuardarNuevaColumna"
               >
                <v-text-field
                  v-model="nuevaColumna.nombreColumna"
                  label="Nombre de columna"
                  variant="outlined"
                  density="comfortable"
                  :rules="[v => !!v || 'Nombre de columna es requerido']"
                  class="mb-3 campo-amarillo"
                ></v-text-field>
              
                 <v-select
                  v-model="nuevaColumna.tipoDato"
                  :items="tiposDato"
                  item-title="texto"
                  item-value="valor"
                  label="Tipo de dato"
                  variant="outlined"
                  density="comfortable"
                  :rules="[v => !!v || 'Tipo de dato es requerido']"
                  class="mb-3 campo-amarillo"
                  @update:modelValue="(val) => { if (val === 'date' || val === 'int') nuevaColumna.longitud = null }"
                ></v-select>
              
                <v-text-field
                  v-model="nuevaColumna.longitud"
                  label="Longitud"
                  type="number"
                  variant="outlined"
                  density="comfortable"
                  class="mb-3 campo-amarillo"
                  :disabled="nuevaColumna.tipoDato === 'date' || nuevaColumna.tipoDato === 'int'"
                ></v-text-field>

                <v-checkbox
                  v-model="nuevaColumna.valoresPredeterminados"
                  label="Valores predeterminados"
                  density="comfortable"
                  hide-details
                ></v-checkbox>
              </v-form>
            </v-col>

            <!-- Columna derecha: Panel de valores predeterminados -->
            <v-col v-if="nuevaColumna.valoresPredeterminados" cols="6">
              <div class="valores-panel">
                <div class="text-subtitle-2 mb-2">Nombre</div>
                
                <div class="d-flex align-center mb-3">
                  <v-text-field
                    v-model="nuevoValorPredeterminado"
                    variant="outlined"
                    density="compact"
                    hide-details
                    placeholder="Ingrese valor"
                    class="mr-2 campo-amarillo"
                    @keyup.enter="agregarValorPredeterminado"
                  ></v-text-field>
                  <v-btn color="#ce501b" size="small" @click="agregarValorPredeterminado">
                    Agregar
                  </v-btn>
                </div>

                <div class="valores-tabla-container">
                  <v-table density="compact" class="valores-tabla">
                    <thead>
                      <tr>
                        <th>Campo</th>
                        <th style="width: 50px;"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(valor, index) in nuevaColumna.listaValores" :key="index">
                        <td>{{ valor }}</td>
                        <td class="text-center">
                          <v-btn icon size="x-small" color="primary" variant="text" @click="abrirModalEditarValor(index, valor)" class="mr-1">
                            <v-icon size="small">mdi-pencil</v-icon>
                          </v-btn>

                          <v-btn icon size="x-small" color="error" variant="text" @click="eliminarValorPredeterminado(index)">
                            <v-icon size="small">mdi-close</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      <tr v-if="nuevaColumna.listaValores.length === 0">
                        <td colspan="2" class="text-center text-grey text-caption">
                          No hay valores agregados
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn type="button" color="#ce501b" variant="elevated" @click="onGuardarNuevaColumna" :loading="guardandoColumna" :disabled="!validFormNuevaColumna">
            Guardar
          </v-btn>
          <v-btn type="button" color="#9B9B9B" variant="elevated" @click="onCerrarModalNuevaColumna">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



       <!-- ==================== MODAL EDITAR VALOR PREDETERMINADO (NUEVA COLUMNA) ==================== -->
    <v-dialog v-model="dialogEditarValor" max-width="400px" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1 py-3 px-4 d-flex align-center">
          Editar campo
          <v-spacer></v-spacer>
          <v-btn icon size="x-small" variant="text" @click="cerrarModalEditarValor">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-4">
          <div class="d-flex align-center">
            <span class="mr-3 text-body-2">Campo</span>
            <v-text-field
              v-model="valorEditando.nuevoValor"
              variant="outlined"
              density="compact"
              hide-details
              class="campo-amarillo"
              autofocus
              @keyup.enter="guardarValorEditado"
            ></v-text-field>
          </div>
        </v-card-text>

        <v-card-actions class="px-4 pb-4">
          <v-btn color="#ce501b" variant="elevated" @click="guardarValorEditado" :disabled="!valorEditando.nuevoValor?.trim()">
            Guardar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#9B9B9B" variant="elevated" @click="cerrarModalEditarValor">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- ==================== MODAL MODIFICAR COLUMNA (CON VALORES PREDETERMINADOS) ==================== -->
    <v-dialog v-model="dialogModificarColumna" :max-width="columnaEditar.valoresPredeterminados ? '750px' : '500px'" persistent>
      <v-card>
        <v-card-title class="text-h6 text-white" style="background-color: #004d82;">
          Modificar detalle plantilla
          <v-spacer></v-spacer>
          <v-btn icon @click="onCerrarModalModificarColumna" size="small" variant="text" color="white">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-row>
            <!-- Columna izquierda: Formulario principal -->
            <v-col :cols="columnaEditar.valoresPredeterminados ? 6 : 12">
              <v-form ref="formModificarColumna" v-model="validFormModificarColumna">
                <v-text-field
                  v-model="columnaEditar.nombreColumna"
                  label="Nombre de columna"
                  variant="outlined"
                  density="comfortable"
                  :rules="[v => !!v || 'Nombre de columna es requerido']"
                  class="mb-3 campo-amarillo"
                ></v-text-field>

               
                  <v-select
                    v-model="columnaEditar.tipoDato"
                    :items="tiposDato"
                    item-title="texto"
                    item-value="valor"
                    label="Tipo de dato"
                    variant="outlined"
                    density="comfortable"
                    :rules="[v => !!v || 'Tipo de dato es requerido']"
                    class="mb-3 campo-amarillo"
                    clearable
                    @update:modelValue="(val) => { if (val === 'date' || val === 'int') columnaEditar.longitud = null }"
                ></v-select>
              
                <v-text-field
                  v-model="columnaEditar.longitud"
                  label="Longitud"
                  type="number"
                  variant="outlined"
                  density="comfortable"
                  class="mb-3 campo-amarillo"
                  :disabled="columnaEditar.tipoDato === 'date' || columnaEditar.tipoDato === 'int'"
                ></v-text-field>

                <v-checkbox
                  v-model="columnaEditar.valoresPredeterminados"
                  label="Valores predeterminados"
                  density="comfortable"
                  hide-details
                ></v-checkbox>
              </v-form>
            </v-col>

            <!-- Columna derecha: Panel de valores predeterminados -->
            <v-col v-if="columnaEditar.valoresPredeterminados" cols="6">
              <div class="valores-panel">
                <div class="text-subtitle-2 mb-2">Nombre</div>
                
                <div class="d-flex align-center mb-3">
                  <v-text-field
                    v-model="nuevoValorPredeterminadoEditar"
                    variant="outlined"
                    density="compact"
                    hide-details
                    placeholder="Ingrese valor"
                    class="mr-2 campo-amarillo"
                    @keyup.enter="agregarValorPredeterminadoEditar"
                  ></v-text-field>
                  <v-btn color="#ce501b" size="small" @click="agregarValorPredeterminadoEditar">
                    Agregar
                  </v-btn>
                </div>

                <div class="valores-tabla-container">
                  <v-table density="compact" class="valores-tabla">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Campo</th>
                        <th style="width: 50px;"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(valor, index) in columnaEditar.listaValores" :key="index">
                        <td>{{ index }} </td>
                        <td>{{ valor.nombre }}</td>
                          <td class="text-center">
                            <v-btn icon size="x-small" color="primary" variant="text" @click="abrirModalEditarValorEditar(index, valor)" class="mr-1">
                              <v-icon size="small">mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn icon size="x-small" color="error" variant="text" @click="eliminarValorPredeterminadoEditar(valor.item)">
                              <v-icon size="small">mdi-close</v-icon>
                            </v-btn>
                        </td>
                      </tr>
                      <tr v-if="columnaEditar.listaValores.length === 0">
                        <td colspan="2" class="text-center text-grey text-caption">
                          No hay valores agregados
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn type="button" color="#ce501b" variant="elevated" @click="onGuardarModificacionColumna" :loading="guardandoColumna" :disabled="!validFormModificarColumna">
            Guardar
          </v-btn>
          <v-btn type="button" color="#9B9B9B" variant="elevated" @click="onCerrarModalModificarColumna">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



  <!-- ==================== MODAL EDITAR VALOR PREDETERMINADO (MODIFICAR COLUMNA) ==================== -->
    <v-dialog v-model="dialogEditarValorEditar" max-width="400px" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1 py-3 px-4 d-flex align-center">
          Editar campo
          <v-spacer></v-spacer>
          <v-btn icon size="x-small" variant="text" @click="cerrarModalEditarValorEditar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-4">
          <div class="d-flex align-center">
            <span class="mr-3 text-body-2">Campo</span>
            <v-text-field
              v-model="valorEditandoEditar.nuevoValor"
              variant="outlined"
              density="compact"
              hide-details
              class="campo-amarillo"
              autofocus
              @keyup.enter="guardarValorEditadoEditar"
            ></v-text-field>
          </div>
        </v-card-text>

        <v-card-actions class="px-4 pb-4">
          <v-btn color="#ce501b" variant="elevated" @click="guardarValorEditadoEditar" :disabled="!valorEditandoEditar.nuevoValor?.trim()">
            Guardar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#9B9B9B" variant="elevated" @click="cerrarModalEditarValorEditar">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
 
  </v-container>
</template>

<script setup>

import { ref, onMounted, onUnmounted, computed, nextTick } from 'vue'
import axios from '@/plugins/axios'
import Swal from 'sweetalert2'

const campoBusquedaRef = ref(null)
const campoPlantillaRef = ref(null)

// ==================== VARIABLES PLANTILLAS ====================
const plantillas = ref([])
const loading = ref(false)
const hayMasDatos = ref(true)
const paginaActual = ref(1)
const itemsPorPagina = ref(20)
const scrollContainer = ref(null)
const busqueda = ref('')
const todasLasPlantillas = ref([])

// Modal nueva plantilla
const dialogNuevaPlantilla = ref(false)
const guardando = ref(false)
const validFormNuevo = ref(false)
const formNuevaPlantilla = ref(null)
const nuevaPlantilla = ref({ plantilla: '' })

// Menú contextual plantillas
const menuContextual = ref({ visible: false, x: 0, y: 0, plantilla: null })

// Modal modificar plantilla
const dialogModificarPlantilla = ref(false)
const plantillaSeleccionada = ref({ codigo: null, plantilla: '' })
const validFormModificar = ref(false)
const formModificarPlantilla = ref(null)
const guardandoModificacion = ref(false)

// ==================== VARIABLES COLUMNAS/DETALLE ====================
const columnasPlantilla = ref([])
const cargandoColumnas = ref(false)
const columnaSeleccionadaIndex = ref(null)

// Menú contextual columnas
const menuColumna = ref({ visible: false, x: 0, y: 0, columna: null, index: null })

// Modal nueva columna
const dialogNuevaColumna = ref(false)
const validFormNuevaColumna = ref(false)
const formNuevaColumna = ref(null)
const guardandoColumna = ref(false)
const nuevoValorPredeterminado = ref('')
const nuevaColumna = ref({
  nombreColumna: '',
  tipoDato: '',
  longitud: null,
  valoresPredeterminados: false,
  listaValores: []
})

// Modal modificar columna
const dialogModificarColumna = ref(false)
const validFormModificarColumna = ref(false)
const formModificarColumna = ref(null)
const nuevoValorPredeterminadoEditar = ref('')
const columnaEditar = ref({
  codigo: null,
  nombreColumna: '',
  tipoDato: '',
  longitud: null,
  valoresPredeterminados: false,
  listaValores: []
})

// Agrega JUSTO DESPUÉS:
const valoresOriginalesEditar = ref([])

// ✅ NUEVA VARIABLE PARA LOADING DURANTE LA BÚSQUEDA DE DETALLE
const cargandoDetalleColumna = ref(false)

// Tipos de dato lo usa para onGuardarNuevaColumna 
const tiposDato = ref([
  { texto: 'fecha', valor: 'date' },
  { texto: 'numero', valor: 'int' },
  { texto: 'texto', valor: 'varchar' }
])

const dialogEditarValor = ref(false)
const valorEditando = ref({
  index: null,
  nuevoValor: ''
})


// Abrir modal con el valor actual
const abrirModalEditarValor = (index, valor) => {
  valorEditando.value = { index, nuevoValor: valor }
  dialogEditarValor.value = true
}

// Guardar el valor editado
const guardarValorEditado = () => {
  nuevaColumna.value.listaValores[valorEditando.value.index] = valorEditando.value.nuevoValor.trim()
  cerrarModalEditarValor()
}

// Modal editar valor predeterminado (modificar columna)
const dialogEditarValorEditar = ref(false)
const valorEditandoEditar = ref({
  index: null,
  tdId: null,
  nuevoValor: ''
})

// ==================== EDITAR VALOR PREDETERMINADO (MODIFICAR COLUMNA) ====================
const abrirModalEditarValorEditar = (index, valor) => {
  valorEditandoEditar.value = {
    index: index,
    tdId: valor.tdId,
    nuevoValor: valor.nombre
  }
  dialogEditarValorEditar.value = true
}

const cerrarModalEditarValorEditar = () => {
  dialogEditarValorEditar.value = false
  valorEditandoEditar.value = { index: null, tdId: null, nuevoValor: '' }
}

const guardarValorEditadoEditar = async () => {
  if (valorEditandoEditar.value.nuevoValor?.trim() && valorEditandoEditar.value.index !== null) {
    columnaEditar.value.listaValores[valorEditandoEditar.value.index].nombre = valorEditandoEditar.value.nuevoValor.trim()

    const codigo = columnaEditar.value.listaValores[valorEditandoEditar.value.index].item

    const playload = {
      nombre: valorEditandoEditar.value.nuevoValor.trim()
    }
    
    const response = await axios.put(`/api/ComboBox/editar-selector/${codigo}`, playload)

    if (response.data.success){
      cerrarModalEditarValorEditar()

      await Swal.fire({
         icon: 'success',
         title: '¡Éxito!',
         iconColor: '#ce501b',
         text: 'Selector actualizado correctamente',
         timer: 2500,
         confirmButtonColor: '#ce501b',
         customClass: { title: 'swal-title-custom', confirmButton: 'swal-btn-confirmar', container: 'swal-sobre-modal'}
      })

    } else {
       Swal.fire(
         {
           icon: 'error',
           iconColor: '#ce501b',
           title: 'Error',
           text: response.data.mensaje || 'Error no se pudo actualizar',
           customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
         }
       )
    }

  }
}

// ==================== CICLO DE VIDA ====================
onMounted(async () => {
  await cargarPlantillas()
  document.addEventListener('click', cerrarMenus)
  document.addEventListener('keydown', handleKeyboardGlobal)
})

onUnmounted(() => {
  document.removeEventListener('click', cerrarMenus)
  document.removeEventListener('keydown', handleKeyboardGlobal)
})

const cerrarMenus = () => {
  menuContextual.value.visible = false
  menuColumna.value.visible = false
}

// ==================== FUNCIONES PLANTILLAS ====================
const cargarPlantillas = async () => {
  if (loading.value || !hayMasDatos.value) return
  loading.value = true
  
  try {
    if (todasLasPlantillas.value.length === 0) {
      const idUsuarioSesion = localStorage.getItem('idUsuario')
      if (!idUsuarioSesion) {
        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo obtener la información del usuario en sesión' })
        loading.value = false
        return
      }

      const response = await axios.get(`/api/Plantillas/list-plantillas?idUsuarioSesion=${idUsuarioSesion}`)
      
      if (response.data.success) {
        todasLasPlantillas.value = response.data.data
      } else {
        Swal.fire({ icon: 'error', title: 'Error', text: response.data.mensaje || 'No se pudieron cargar las plantillas' })
        return
      }
    }
    
    const inicio = (paginaActual.value - 1) * itemsPorPagina.value
    const fin = inicio + itemsPorPagina.value
    const itemsPaginados = todasLasPlantillas.value.slice(inicio, fin)
    
    if (itemsPaginados.length > 0) {
      plantillas.value = [...plantillas.value, ...itemsPaginados]
      paginaActual.value++
    }
    
    if (fin >= todasLasPlantillas.value.length) {
      hayMasDatos.value = false
    }
  } catch (error) {
    //console.error('Error al cargar plantillas:', error)    //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({ icon: 'error', title: 'Error', text: 'Hubo un problema al cargar las plantillas' })
  } finally {
    loading.value = false
  }
}

const handleScroll = (event) => {
  const { scrollTop, scrollHeight, clientHeight } = event.target
  if (scrollTop + clientHeight >= scrollHeight * 0.8) {
    cargarPlantillas()
  }
}

const recargarDesdeInicio = () => {
  plantillas.value = []
  todasLasPlantillas.value = []
  paginaActual.value = 1
  hayMasDatos.value = true
  cargarPlantillas()
}

const plantillasFiltradas = computed(() => {
  if (!busqueda.value) return plantillas.value
  const termino = busqueda.value.toLowerCase()
  return plantillas.value.filter(p => p.codigo?.toString().includes(termino) || p.plantilla?.toLowerCase().includes(termino))
})

// ==================== MENÚ CONTEXTUAL PLANTILLAS ====================
const onContextMenuPlantilla = (event, plantilla) => {
  event.preventDefault()
  event.stopPropagation()
  menuColumna.value.visible = false
  menuContextual.value = { visible: true, x: event.clientX, y: event.clientY, plantilla }
}

// ==================== MODAL NUEVA PLANTILLA ====================
const abrirModalNuevaPlantilla = () => {
  limpiarFormularioNuevo()
  dialogNuevaPlantilla.value = true
  nextTick(() => {
    setTimeout(() => {
      const input = campoPlantillaRef.value?.$el?.querySelector('input')
      if (input) input.focus()
    }, 100)
  })
}


const handleKeyboardGlobal = (event) => {
  // Alt + N → abrir modal Nueva Plantilla
  if (event.altKey && event.code === 'KeyN') {
    event.preventDefault()
    if (!dialogNuevaPlantilla.value && !dialogModificarPlantilla.value &&
        !dialogNuevaColumna.value && !dialogModificarColumna.value) {
      abrirModalNuevaPlantilla()
    }
  }

  // Alt + G → guardar según el modal abierto
  if (event.altKey && event.code === 'KeyG') {
    event.preventDefault()
    if (dialogNuevaPlantilla.value) {
      onGuardarPlantilla()
    } else if (dialogModificarPlantilla.value) {
      onGuardarModificacionPlantilla()
    } else if (dialogNuevaColumna.value) {
      onGuardarNuevaColumna()
    } else if (dialogModificarColumna.value) {
      onGuardarModificacionColumna()
    }
  }

  // Alt + B → enfocar buscador
  if (event.altKey && event.code === 'KeyB') {
    event.preventDefault()
    if (!dialogNuevaPlantilla.value && !dialogModificarPlantilla.value &&
        !dialogNuevaColumna.value && !dialogModificarColumna.value) {
      const input = campoBusquedaRef.value?.$el?.querySelector('input')
      if (input) input.focus()
    }
  }

  // ESC → cerrar modal según cuál esté abierto
  if (event.key === 'Escape') {
    if (dialogModificarColumna.value) {
      event.preventDefault()
      onCerrarModalModificarColumna()
    } else if (dialogNuevaColumna.value) {
      event.preventDefault()
      onCerrarModalNuevaColumna()
    } else if (dialogModificarPlantilla.value) {
      event.preventDefault()
      onCerrarModalModificar()
    } else if (dialogNuevaPlantilla.value) {
      event.preventDefault()
      onCerrarModalNuevo()
    }
  }
}





const onCerrarModalNuevo = () => {
  dialogNuevaPlantilla.value = false
  limpiarFormularioNuevo()
}

const limpiarFormularioNuevo = () => {
  nuevaPlantilla.value = { plantilla: '' }
  if (formNuevaPlantilla.value) formNuevaPlantilla.value.reset()
}

const onGuardarPlantilla = async () => {
  const { valid } = await formNuevaPlantilla.value.validate()
  if (!valid) return

  guardando.value = true
  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    if (!idUsuarioSesion) {
      Swal.fire({ 
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: 'No se pudo obtener la información del usuario en sesión',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' } })
      guardando.value = false
      return
    }

    const response = await axios.post(`/api/Plantillas/registrar-plantilla?idUsuarioSesion=${idUsuarioSesion}`, { plantilla: nuevaPlantilla.value.plantilla })

    if (response.data.success) {
      onCerrarModalNuevo()
      await Swal.fire({ 
        icon: 'success',
        title: '¡Éxito!',
        iconColor: '#ce501b',
        confirmButtonColor: '#ce501b',
        text: 'Plantilla registrada correctamente',
        timer: 2500,
        showConfirmButton: true,
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal', confirmButton: 'swal-btn-confirmar'} })
      recargarDesdeInicio()
    } else {
      Swal.fire({ 
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: response.data.mensaje || 'No se pudo registrar la plantilla' ,
        customClass: { container: 'swal-sobre-modal', title: 'swal-title-custom' }
       })
    }
  } catch (error) {
    //console.error('Error al guardar plantilla:', error)     //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
       icon: 'error',
       iconColor: '#ce501b',
       title: 'Error', text: error.response?.data?.mensaje || 'Hubo un problema al guardar la plantilla' ,
       customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
       })
  } finally {
    guardando.value = false
  }
}

// ==================== MODAL MODIFICAR PLANTILLA ====================
const onModificarPlantilla = () => {
  menuContextual.value.visible = false
  if (!menuContextual.value.plantilla) return

  plantillaSeleccionada.value = {
    codigo: menuContextual.value.plantilla.codigo,
    plantilla: menuContextual.value.plantilla.plantilla
  }
  dialogModificarPlantilla.value = true
  cargarColumnasPlantilla(plantillaSeleccionada.value.codigo)
}

const onCerrarModalModificar = () => {
  dialogModificarPlantilla.value = false
  plantillaSeleccionada.value = { codigo: null, plantilla: '' }
  columnasPlantilla.value = []
  columnaSeleccionadaIndex.value = null
}

const cargarColumnasPlantilla = async (codigoPlantilla) => {
  cargandoColumnas.value = true
  columnasPlantilla.value = []

  try {
    const response = await axios.get(`/api/Plantillas/detalle-listado/${codigoPlantilla}`)
    if (response.data.success) {
      columnasPlantilla.value = response.data.data || []
    }
  } catch (error) {
    //console.error('Error al cargar columnas:', error)        //Usarlo solo para ver los errores en el testeo de Software
  } finally {
    cargandoColumnas.value = false
  }
}

const onGuardarModificacionPlantilla = async () => {
  const { valid } = await formModificarPlantilla.value.validate()
  if (!valid) return

  guardandoModificacion.value = true
  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    const response = await axios.put(`/api/Plantillas/actualizar-plantilla?idUsuarioSesion=${idUsuarioSesion}`, {
      idPlantilla: plantillaSeleccionada.value.codigo,
      plantilla: plantillaSeleccionada.value.plantilla
    })

    if (response.data.success) {
      onCerrarModalModificar()
      await Swal.fire({ 
          icon: 'success',
          iconColor: '#ce501b', 
          title: '¡Éxito!', 
          confirmButtonColor: '#ce501b', 
          text: 'Plantilla modificada correctamente',     
          customClass: {
           title: 'swal-title-custom',
           confirmButton: 'swal-btn-confirmar',
           container: 'swal-sobre-modal',
          }, 
          timer: 2500, 
          showConfirmButton: true
          })
      recargarDesdeInicio()
    } else {
      Swal.fire({ 
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: response.data.mensaje || 'No se pudo modificar la plantilla',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        } 
      })
    }
  } catch (error) {
    //console.error('Error al modificar plantilla:', error)          //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({ 
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.response?.data?.mensaje || 'Hubo un problema al modificar la plantilla',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      })
  } finally {
    guardandoModificacion.value = false
  }
}

// ==================== ELIMINAR PLANTILLA ====================
const onEliminarPlantilla = async () => {
  menuContextual.value.visible = false
  if (!menuContextual.value.plantilla) return

  const plantilla = menuContextual.value.plantilla
  const result = await Swal.fire({
    icon: 'warning',
    title: '¿Eliminar plantilla?',
    iconColor: '#ce501b',
    text: `¿Está seguro de eliminar la plantilla "${plantilla.plantilla}"?`,
    showCancelButton: true,
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9B9B9B',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    customClass: {
          title: 'swal-title-custom',
          confirmButton: 'swal-btn-confirmar',
          cancelButton: 'swal-btn-cancelar',
          container: 'swal-sobre-modal'
    }
  })

  if (result.isConfirmed) {
    try {
      const idUsuarioSesion = localStorage.getItem('idUsuario')
      const response = await axios.delete(`/api/Plantillas/eliminar-plantilla/${plantilla.codigo}?idUsuarioSesion=${idUsuarioSesion}`)

      if (response.data.success) {
        await Swal.fire({
           icon: 'success',
           iconColor: '#ce501b',
           title: 'Eliminado',
           confirmButtonColor: '#ce501b',
           text: 'Plantilla eliminada correctamente',  
          customClass: {
            title: 'swal-title-custom',
            confirmButton: 'swal-btn-confirmar',
            container: 'swal-sobre-modal'
          },
          timer: 2000 })
        recargarDesdeInicio()
      } else {
        Swal.fire({ icon: 'error', title: 'Error', text: response.data.mensaje || 'No se pudo eliminar la plantilla' })
      }
    } catch (error) {
      //console.error('Error al eliminar:', error)          //Usarlo solo para ver los errores en el testeo de Software
      Swal.fire({ 
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: error.response?.data?.mensaje || 'Hubo un problema al eliminar la plantilla',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      })
    }
  }
}

// ==================== FUNCIONES COLUMNAS ====================
const onSeleccionarColumna = (index) => {
  columnaSeleccionadaIndex.value = index
}

const onContextMenuColumna = (event, columna, index) => {
  event.preventDefault()
  event.stopPropagation()
  menuContextual.value.visible = false
  columnaSeleccionadaIndex.value = index
  menuColumna.value = { visible: true, x: event.clientX, y: event.clientY, columna, index }
}

// ==================== MODAL NUEVA COLUMNA ====================
const onAbrirModalNuevaColumna = () => {
  limpiarFormularioNuevaColumna()
  dialogNuevaColumna.value = true
}

const onCerrarModalNuevaColumna = () => {
  dialogNuevaColumna.value = false
  limpiarFormularioNuevaColumna()
}

const limpiarFormularioNuevaColumna = () => {
  nuevaColumna.value = { nombreColumna: '', tipoDato: '', longitud: null, valoresPredeterminados: false, listaValores: [] }
  nuevoValorPredeterminado.value = ''
  if (formNuevaColumna.value) formNuevaColumna.value.reset()
}

// Agregar valor predeterminado (modal nueva columna)
const agregarValorPredeterminado = () => {
  if (nuevoValorPredeterminado.value.trim()) {
    nuevaColumna.value.listaValores.push(nuevoValorPredeterminado.value.trim())
    nuevoValorPredeterminado.value = ''
  }
}

// Eliminar valor predeterminado (modal nueva columna)
const eliminarValorPredeterminado = (index) => {
  nuevaColumna.value.listaValores.splice(index, 1)
}


const cerrarModalEditarValor = () => {
  dialogEditarValor.value = false
  valorEditando.value = { index: null, nuevoValor: '' }
}


// ==================== LUEGO, REEMPLAZA onGuardarNuevaColumna CON ESTO ====================

const onGuardarNuevaColumna = async () => {
  const { valid } = await formNuevaColumna.value.validate()
  if (!valid) return

  // Calcular el siguiente nroOrden basado en las columnas existentes
  const siguienteOrden = columnasPlantilla.value.length + 1

  // Determinar la longitud según el tipo de dato
  let longitudFinal = null
  if (nuevaColumna.value.tipoDato === 'varchar') {
    longitudFinal = nuevaColumna.value.longitud ? nuevaColumna.value.longitud.toString() : '50'
  } else if (nuevaColumna.value.tipoDato === 'int') {
    longitudFinal = nuevaColumna.value.longitud ? nuevaColumna.value.longitud.toString() : '4'
  } else if (nuevaColumna.value.tipoDato === 'date'){
    longitudFinal = '8'
  }
  // Para datetime no se necesita longitud
  
  // Limpiar el nombre de columna (sin espacios ni caracteres especiales)
  const nombreColumnaLimpio = nuevaColumna.value.nombreColumna
    .trim()
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9_áéíóúüñÁÉÍÓÚÜÑ]/g, '')

  const payload = {
    idPlantilla: plantillaSeleccionada.value.codigo,
    columna: nombreColumnaLimpio,
    tipoDato: nuevaColumna.value.tipoDato,
    longitud: longitudFinal,
    estadoCheck: nuevaColumna.value.valoresPredeterminados ? 1 : 0,
    nroOrden: siguienteOrden
  }

  //console.log('Payload para crear columna:', payload)      //Usarlo solo para ver los errores en el testeo de Software

  guardandoColumna.value = true
  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    const response = await axios.post(`/api/Plantillas/agregar-detalle?idUsuarioSesion=${idUsuarioSesion}`, payload)

    if (response.data.success) {
      // Obtener el código del campo recién creado
      const codigoCampoCreado = response.data.data?.codigo
      
      //console.log('Columna creada con código:', codigoCampoCreado)                            //Usarlo solo para ver los errores en el testeo de Software

      // ==================== INSERTAR VALORES PREDETERMINADOS EN COMBOBOX ====================
      if (nuevaColumna.value.valoresPredeterminados && 
          nuevaColumna.value.listaValores.length > 0 && 
          codigoCampoCreado) {
        
        //console.log('Insertando valores predeterminados para el campo:', codigoCampoCreado)     //Usarlo solo para ver los errores en el testeo de Software
        //console.log('Valores a insertar:', nuevaColumna.value.listaValores)                     //Usarlo solo para ver los errores en el testeo de Software
        
        const resultado = await insertarValoresComboBox(codigoCampoCreado, nuevaColumna.value.listaValores)
        
        // Mostrar resultado
        if (resultado.errores.length === 0) {
          // Todos los valores se insertaron correctamente
          onCerrarModalNuevaColumna()
          await Swal.fire({ 
            icon: 'success', 
            title: '¡Éxito!', 
            iconColor: '#ce501b',
            html: `Columna creada correctamente.<br><br>Se insertaron <strong>${resultado.insertados.length}</strong> valores predeterminados.`, 
            timer: 3000, 
            confirmButtonColor: '#ce501b',
            customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal', confirmButton: 'swal-btn-confirmar' } 
          })
        } else if (resultado.insertados.length > 0) {
          // Algunos valores se insertaron, otros fallaron
          onCerrarModalNuevaColumna()
          const valoresConError = resultado.errores.map(e => `• ${e.valor}: ${e.mensaje}`).join('<br>')
          await Swal.fire({ 
            icon: 'warning', 
            iconColor: '#ce501b',
            confirmButtonColor: '#ce501b',
            title: 'Columna creada con advertencias', 
            html: `Columna creada correctamente.<br><br>
                   ✅ Valores insertados: <strong>${resultado.insertados.length}</strong><br>
                   ⚠️ Valores con error: <strong>${resultado.errores.length}</strong><br><br>
                   <small>${valoresConError}</small>`, 
            customClass: { container: 'swal-sobre-modal', title: 'swal-title-custom', confirmButton: 'swal-btn-confirmar' } 
          })
        } else {
          // Ningún valor se insertó
          onCerrarModalNuevaColumna()
          await Swal.fire({ 
            icon: 'warning', 
            iconColor: '#ce501b',
            title: 'Columna creada', 
            html: `La columna se creó pero no se pudieron insertar los valores predeterminados.<br><br>
                   Puede agregarlos manualmente desde el módulo de edición.`, 
            confirmButtonColor: '#ce501b',       
            customClass: {  title: 'swal-title-custom', container: 'swal-sobre-modal', confirmButton: 'swal-btn-confirmar' } 
          })
        }
      } else {
        // Sin valores predeterminados
        onCerrarModalNuevaColumna()
        await Swal.fire({ 
          icon: 'success', 
          iconColor: '#ce501b',
          title: '¡Éxito!', 
          text: 'Columna registrada correctamente', 
          timer: 2000, 
          confirmButtonColor: '#ce501b',
          customClass: { title: 'swal-title-custom', confirmButton: 'swal-btn-confirmar', container: 'swal-sobre-modal' } 
        })
      }
      
      // Recargar las columnas
      await cargarColumnasPlantilla(plantillaSeleccionada.value.codigo)
      
    } else {
      Swal.fire({ 
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error', 
        text: response.data.mensaje || 'No se pudo registrar la columna', 
        confirmButtonColor: '#ce501b',
        customClass: { title: 'swal-title-custom', confirmButton: 'swal-btn-confirmar', container: 'swal-sobre-modal' } 
      })
    }
  } catch (error) {
    //console.error('Error al guardar columna:', error)            //Usarlo solo para ver los errores en el testeo de Software
    
    let mensajeError = 'Hubo un problema al guardar la columna'
    if (error.response?.data?.mensaje) {
      mensajeError = error.response.data.mensaje
    } else if (error.response?.data) {
      mensajeError = JSON.stringify(error.response.data)
    }
    
    Swal.fire({ 
      icon: 'error', 
      title: 'Error', 
      text: mensajeError, 
      customClass: { container: 'swal-sobre-modal' } 
    })
  } finally {
    guardandoColumna.value = false
  }
}


// ==================== FUNCIÓN PARA CARGAR VALORES PREDETERMINADOS ====================
const cargarValoresPredeterminados = async (codigoCampo) => {
  try {
    //console.log('Cargando valores predeterminados para código:', codigoCampo)    //Usarlo solo para ver los errores en el testeo de Software
    
    const response = await axios.get(
      `/api/ComboBox/listar-por-codigo/${codigoCampo}`
    )

    //console.log('Respuesta del API listar-por-codigo:', response.data)      //Usarlo solo para ver los errores en el testeo de Software

    if (response.data.success && response.data.data && response.data.data.length > 0) {
      // Mapear los valores devueltos del API al array listaValores
      // El API retorna: { item, tdId, nombre, nombreCampo }
      // Usamos el campo "nombre" como el valor
      //const valores = response.data.data.map(item => item.nombre)           //Usarlo solo para ver los errores en el testeo de Software
       
      //console.log('Valores cargados:', valores)                             //Usarlo solo para ver los errores en el testeo de Software
      //console.log('Valores cargados:', response.data.data)                  //Usarlo solo para ver los errores en el testeo de Software
      return response.data.data
      //return valores
    } else {
      //console.warn('No hay valores predeterminados para este campo')        //Usarlo solo para ver los errores en el testeo de Software
      return []
    }
  } catch (error) {
    //console.error('Error al cargar valores predeterminados:', error)         //Usarlo solo para ver los errores en el testeo de Software
    return []
  }
}



const onModificarColumna = async () => {
  menuColumna.value.visible = false
  if (!menuColumna.value.columna) return

  const columna = menuColumna.value.columna
  cargandoDetalleColumna.value = true

  // ✅ IMPORTANTE: Limpiar valores originales al inicio
  valoresOriginalesEditar.value = []

  try {
    const response = await axios.get(
      `/api/Plantillas/buscar-detalle/${columna.codigo}`
    )

    //console.log('Respuesta del API buscar-detalle:', response.data)                                   //Usarlo solo para ver los errores en el testeo de Software

    if (response.data.success && response.data.data) {
      const detalleColumna = response.data.data

      columnaEditar.value = {
        codigo: detalleColumna.codigo || columna.codigo,
        nombreColumna: detalleColumna.nombre_Campo || detalleColumna.nombreColumna || columna.nombre_Campo,
        tipoDato: detalleColumna.tipo || detalleColumna.tipo_Dato || detalleColumna.tipoDato || '',
        longitud: detalleColumna.longitud || null,
        valoresPredeterminados: detalleColumna.comboBox === 1,
        listaValores: []
      }

      //console.log('Datos básicos cargados en columnaEditar:', columnaEditar.value)                       //Usarlo solo para ver los errores en el testeo de Software

      // ==================== CARGAR VALORES PREDETERMINADOS SI ESTÁN ACTIVADOS ====================
      if (columnaEditar.value.valoresPredeterminados && columnaEditar.value.codigo) {
        //console.log('Cargando valores predeterminados para el código:', columnaEditar.value.codigo)      //Usarlo solo para ver los errores en el testeo de Software
        const valores = await cargarValoresPredeterminados(columnaEditar.value.codigo)
        
        // ✅ IMPORTANTE: Asignar a listaValores
        columnaEditar.value.listaValores = [...valores]
        
        // ✅ CRÍTICO: Guardar copia INDEPENDIENTE de los valores originales
        valoresOriginalesEditar.value = valores.map(v => v) // Copia profunda
        
        //console.log('========================================')                            //Usarlo solo para ver los errores en el testeo de Software
        //console.log('✅ Valores originales GUARDADOS:', valoresOriginalesEditar.value)    //Usarlo solo para ver los errores en el testeo de Software
        //console.log('✅ Cantidad de originales:', valoresOriginalesEditar.value.length)   //Usarlo solo para ver los errores en el testeo de Software
        //console.log('========================================')                           //Usarlo solo para ver los errores en el testeo de Software
        
      } else {
        valoresOriginalesEditar.value = []
        //console.log('Sin valores predeterminados, originales vacío')               //Usarlo solo para ver los errores en el testeo de Software
      }

      nuevoValorPredeterminadoEditar.value = ''
      dialogModificarColumna.value = true

    } else {
      //console.warn('El API no retornó datos de éxito, usando datos de fallback')      //Usarlo solo para ver los errores en el testeo de Software
      
      columnaEditar.value = {
        codigo: columna.codigo,
        nombreColumna: columna.nombre_Campo,
        tipoDato: columna.tipoDato || columna.tipo_Dato,
        longitud: columna.longitud,
        valoresPredeterminados: columna.valoresPredeterminados || columna.valores_Predeterminados || false,
        listaValores: columna.listaValores || columna.lista_Valores || []
      }
      
      // ✅ También guardar originales en fallback
      valoresOriginalesEditar.value = [...(columnaEditar.value.listaValores || [])]

      nuevoValorPredeterminadoEditar.value = ''
      dialogModificarColumna.value = true
    }

  } catch (error) {
    //console.error('Error al cargar detalle de columna:', error)     //Usarlo solo para ver los errores en el testeo de Software

    columnaEditar.value = {
      codigo: columna.codigo,
      nombreColumna: columna.nombre_Campo,
      tipoDato: columna.tipoDato || columna.tipo_Dato,
      longitud: columna.longitud,
      valoresPredeterminados: columna.valoresPredeterminados || columna.valores_Predeterminados || false,
      listaValores: columna.listaValores || columna.lista_Valores || []
    }
    
    // ✅ También guardar originales en caso de error
    valoresOriginalesEditar.value = [...(columnaEditar.value.listaValores || [])]

    nuevoValorPredeterminadoEditar.value = ''
    dialogModificarColumna.value = true

    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.response?.data?.mensaje || 'No se pudieron cargar todos los detalles de la columna',
      timer: 3000,
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    })
  } finally {
    cargandoDetalleColumna.value = false
  }
}





const onCerrarModalModificarColumna = () => {
  dialogModificarColumna.value = false
  columnaEditar.value = { 
    codigo: null, 
    nombreColumna: '', 
    tipoDato: '', 
    longitud: null, 
    valoresPredeterminados: false, 
    listaValores: [] 
  }
  nuevoValorPredeterminadoEditar.value = ''
  
  // ✅ IMPORTANTE: Limpiar valores originales al cerrar
  valoresOriginalesEditar.value = []
}




// Agregar valor predeterminado (modal editar columna)
const agregarValorPredeterminadoEditar = async () => {
  if (nuevoValorPredeterminadoEditar.value.trim()) {
      
    const codigo = columnaEditar.value.codigo
    
    const payload = {
      registro: nuevoValorPredeterminadoEditar.value.trim()
    }
  
    const response = await axios.post(
      `/api/ComboBox/agregar-editar-selector/${codigo}`, payload
    )

    if (response.data.success){
      await Swal.fire({
        icon: 'success',
        iconColor: '#ce501b',
        title: 'Agreado',
        text: 'Agregado correctamente',
        timer: 2000,
        confirmButtonColor: '#ce501b',
        customClass: {  
          title: 'swal-title-custom',
          confirmButton: 'swal-btn-confirmar',
          container: 'swal-sobre-modal'}
       })
       //console.log('agregar selector - codigo: ', plantillaSeleccionada.value.codigo)             //Usarlo solo para ver los errores en el testeo de Software
       //console.log('agregar selector - registro:', nuevoValorPredeterminadoEditar.value.trim())   //Usarlo solo para ver los errores en el testeo de Software
       await onModificarColumna();
    } else {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          confirmButtonColor: '#ce501b',
          title: 'Error',
          text: response.data.mensaje || 'No aw pudo agregar selector',
          customClass: { confirmButton: 'swal-btn-confirmar', title: 'swal-title-custom', container: 'swal-sobre-modal'}
        }) 
    }
  }
}

// Eliminar valor predeterminado (modal editar columna)
const eliminarValorPredeterminadoEditar = async (tdId) => {
   const result = await Swal.fire({
        icon: 'warning',
        title: '¿Eliminar columna?',
        iconColor: '#ce501b',
        text: `¿Está seguro de eliminar?`,
        showCancelButton: true,
        confirmButtonColor: '#ce501b',
        cancelButtonColor: '#9B9B9B',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        customClass: { title: 'swal-title-custom', confirmButton: 'swal-btn-confirmar', container: 'swal-sobre-modal' }
   })

   if (result.isConfirmed){
     try {
       const response = await axios.delete(`/api/ComboBox/eliminar-selector/${tdId}`)
       
       if (response.data.success) {
        await Swal.fire({ icon: 'success', iconColor: '#ce501b', title: 'Eliminado',  text: 'Eliminada correctamente', confirmButtonColor: '#ce501b', timer: 2000, customClass: { title: 'swal-title-custom', confirmButton: 'swal-btn-confirmar', container: 'swal-sobre-modal' } })
        await onModificarColumna();
       } else {
         Swal.fire({
           icon: 'error',
           iconColor: '#ce501b',
           title: 'Error',
           confirmButtonColor: '#ce501b',
           text: response.data.mensaje || 'No se pudo eliminar la columna',
           customClass: { title: 'swal-title-custom', confirmButton: 'swal-btn-confirmar', container: 'swal-sobre-modal' } })
       }

     } catch (error) {
      //console.error('Error en eliminar selector', error)      //Usarlo solo para ver los errores en el testeo de Software
      Swal.fire({ 
        icon: 'error',
        iconColor: '#ce501b',
        confirmButtonColor: '#ce501b',
        title: 'Error',
        text: error.response?.data?.mensaje || 'Hubo un problema al eliminar el selector',
        customClass: { title: 'swal-title-custom', confirmButton: 'swal-btn-confirmar', container: 'swal-sobre-modal'} })
     }

   }

}



const onGuardarModificacionColumna = async () => {
  const { valid } = await formModificarColumna.value.validate()
  if (!valid) return

  // Determinar la longitud según el tipo de dato
  let longitudFinal = null
  if (columnaEditar.value.tipoDato === 'varchar') {
    longitudFinal = columnaEditar.value.longitud ? columnaEditar.value.longitud.toString() : '50'
  } else if (columnaEditar.value.tipoDato === 'int') {
    longitudFinal = columnaEditar.value.longitud ? columnaEditar.value.longitud.toString() : '4'
  } else if (columnaEditar.value.tipoDato === 'date') {
    longitudFinal = '8'
  }

  // Limpiar el nombre de columna
  const nombreColumnaLimpio = columnaEditar.value.nombreColumna
    .trim()
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9_áéíóúüñÁÉÍÓÚÜÑ]/g, '')

  const payload = {
    CodField: columnaEditar.value.codigo,
    columna: nombreColumnaLimpio,
    tipoDato: columnaEditar.value.tipoDato,
    longitud: longitudFinal,
    estadoCheck: columnaEditar.value.valoresPredeterminados ? 1 : 0
  }

  //console.log('Payload para modificar columna:', payload)      //Usarlo solo para ver los errores en el testeo de Software

  guardandoColumna.value = true
  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    
    // ==================== PASO 1: ACTUALIZAR DETALLE (Tbl_Fields) ====================
    const response = await axios.put(
      `/api/Plantillas/actualizar-detalle?idUsuarioSesion=${idUsuarioSesion}`, 
      payload
    )

    if (!response.data.success) {
      Swal.fire({ 
        icon: 'error', 
        iconColor: '#ce501b',
        title: 'Error', 
        text: response.data.mensaje || 'No se pudo modificar la columna', 
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' } 
      })
      return
    }

    // ==================== PASO 2: SINCRONIZAR VALORES PREDETERMINADOS ====================
    let mensajeResultado = 'Columna modificada correctamente'
    
    /* //Solo sirve para testeo de depuracion
    if (columnaEditar.value.valoresPredeterminados) {
      //console.log('Sincronizando valores predeterminados...')   //Usarlo solo para ver los errores en el testeo de Software
      
      // ✅ IMPORTANTE: Crear copias de los arrays para la sincronización
      const originales = [...valoresOriginalesEditar.value]
      const nuevos = [...columnaEditar.value.listaValores]
      
      console.log('========================================')    //Usarlo solo para ver los errores en el testeo de Software
      console.log('🔵 ORIGINALES para comparar:', originales)   //Usarlo solo para ver los errores en el testeo de Software
      console.log('🔵 Cantidad originales:', originales.length) //Usarlo solo para ver los errores en el testeo de Software
      console.log('🟢 NUEVOS para comparar:', nuevos)           //Usarlo solo para ver los errores en el testeo de Software
      console.log('🟢 Cantidad nuevos:', nuevos.length)         //Usarlo solo para ver los errores en el testeo de Software
      console.log('========================================')    //Usarlo solo para ver los errores en el testeo de Software
      
    
    } else {
      console.log('Valores predeterminados deshabilitados - el SP eliminará los registros')   //Usarlo solo para ver los errores en el testeo de Software
    } */

    // ==================== PASO 3: MOSTRAR ÉXITO ====================
    onCerrarModalModificarColumna()
    await Swal.fire({ 
      icon: 'success', 
      title: '¡Éxito!', 
      iconColor: '#ce501b',
      html: mensajeResultado,
      confirmButtonColor: '#ce501b', 
      timer: 2500, 
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal', confirmButton: 'swal-btn-confirmar' } 
    })
    await cargarColumnasPlantilla(plantillaSeleccionada.value.codigo)

  } catch (error) {
    //console.error('Error al modificar columna:', error)     //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({ 
      icon: 'error', 
      iconColor: '#ce501b',
      title: 'Error', 
      text: error.response?.data?.mensaje || 'Hubo un problema al modificar la columna', 
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' } 
    })
  } finally {
    guardandoColumna.value = false
  }
}





// ==================== ELIMINAR COLUMNA ====================
const onEliminarColumna = async () => {
  menuColumna.value.visible = false
  if (!menuColumna.value.columna) return

  const columna = menuColumna.value.columna
  const result = await Swal.fire({
    icon: 'warning',
    iconColor: '#ce501b',
    title: '¿Eliminar columna?',
    text: `¿Está seguro de eliminar la columna "${columna.nombre_Campo}"?`,
    showCancelButton: true,
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9B9B9B',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    customClass: { title: 'swal-title-custom', confirmButton: 'swal-btn-confirmar', container: 'swal-sobre-modal', cancelButton: 'swal-btn-cancelar' }
  })

  if (result.isConfirmed) {
    try {
      const idUsuarioSesion = localStorage.getItem('idUsuario')
      const response = await axios.delete(`/api/Plantillas/eliminar-detalle?codField=${columna.codigo}&idUsuarioSesion=${idUsuarioSesion}`)

      if (response.data.success) {
        await Swal.fire({ icon: 'success', title: 'Eliminado', text: 'Columna eliminada correctamente', timer: 2000, customClass: { container: 'swal-sobre-modal' } })
        await cargarColumnasPlantilla(plantillaSeleccionada.value.codigo)
      } else {
        Swal.fire({ 
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: response.data.mensaje || 'No se pudo eliminar la columna',
          customClass: { container: 'swal-sobre-modal', title: 'swal-title-custom' }
         })
      }
    } catch (error) {
      //console.error('Error al eliminar columna:', error)      //Usarlo solo para ver los errores en el testeo de Software
      Swal.fire({
         icon: 'error',
         iconColor: '#ce501b',
         title: 'Error',
         text: error.response?.data?.mensaje || 'Hubo un problema al eliminar la columna',
         customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' } 
        })
    }
  }
}


// ==================== FUNCIÓN PARA INSERTAR VALORES EN COMBOBOX ====================
const insertarValoresComboBox = async (codigoCampo, listaValores) => {
  const errores = []
  const insertados = []

  for (const valor of listaValores) {
    try {
      const payload = {
        codigo: codigoCampo,
        registro: valor
      }
      
      //console.log('Insertando valor en ComboBox:', payload)           //Usarlo solo para ver los errores en el testeo de Software
      
      const response = await axios.post('/api/ComboBox/insertar', payload)
      
      if (response.data.success) {
        insertados.push(valor)
        //console.log(`✅ Valor "${valor}" insertado correctamente`)      //Usarlo solo para ver los errores en el testeo de Software
      } else {
        errores.push({ valor, mensaje: response.data.mensaje || 'Error desconocido' })
        //console.warn(`⚠️ No se pudo insertar "${valor}": ${response.data.mensaje}`)       //Sirve para testear errores
      }
    } catch (error) {
      const mensajeError = error.response?.data?.mensaje || error.message
      errores.push({ valor, mensaje: mensajeError })
      //console.error(`❌ Error al insertar "${valor}":`, mensajeError)                     //Solo sirve para testear errores
    }
  }

  return { insertados, errores }
}


</script>

<style scoped>
.plantillas-container {
  max-height: calc(100vh - 360px);
  overflow-y: auto;
  padding-right: 8px;
}

.plantillas-container::-webkit-scrollbar { width: 8px; }
.plantillas-container::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 10px; }
.plantillas-container::-webkit-scrollbar-thumb { background: #888; border-radius: 10px; }
.plantillas-container::-webkit-scrollbar-thumb:hover { background: #555; }

.plantillas-table { background-color: transparent; }
.plantillas-table th { background-color: #def2ff !important; font-weight: bold !important; color: #37495f !important; white-space: nowrap; }
.plantilla-row { transition: background-color 0.2s ease; cursor: pointer; }
.plantilla-row:hover { background-color: rgba(59, 130, 200, 0.1); }
.plantillas-table td { padding: 12px 16px !important; }

.detalle-container { max-height: 300px; overflow-y: auto; border: 1px solid #e0e0e0; border-radius: 4px; }
.detalle-table th { background-color: #def2ff !important; font-weight: bold !important; color: #37495f !important; }
.detalle-row { cursor: pointer; transition: background-color 0.2s ease; }
.detalle-row:hover { background-color: rgba(59, 130, 200, 0.1); }
.fila-seleccionada { background-color: rgba(25, 118, 210, 0.15) !important; }

.menu-contextual-custom { position: fixed; background: white; border: 1px solid #e0e0e0; border-radius: 4px; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2); z-index: 9999; min-width: 150px; padding: 4px 0; }
.menu-item { display: flex; align-items: center; padding: 8px 16px; cursor: pointer; font-size: 14px; transition: background-color 0.2s; }
.menu-item:hover { background-color: #f5f5f5; }

:deep(.campo-amarillo .v-field) { background-color: #FFFACD !important; }






</style>

<style>

/* Panel de valores predeterminados */
.valores-panel { border-left: 1px solid #e0e0e0; padding-left: 16px; height: 100%; }
.valores-tabla-container { max-height: 200px; overflow-y: auto; border: 1px solid #e0e0e0; border-radius: 4px; }
.valores-tabla thead tr th { background-color: #def2ff !important; font-weight: bold !important; font-size: 12px; }
.valores-tabla td { font-size: 13px; }

/* ✅ Agrega estas dos */
.plantillas-table thead tr th { 
  background-color: #def2ff !important; 
  font-weight: bold !important; 
  color: #37495f !important; 
  white-space: nowrap; 
}

.detalle-table thead tr th { 
  background-color: #def2ff !important; 
  font-weight: bold !important; 
  color: #37495f !important; 
}

</style>



<style>
.swal-sobre-modal { z-index: 99999 !important; }
</style>

<style>
  
.swal-title-custom {
  color: #004d82 !important;
  font-size: 1.3rem !important;
}

.swal-text-custom {
  color: #555555 !important;
  font-size: 0.95rem !important;
}

.swal-btn-custom {
  background-color: #ce501b !important;
  color: #ffffff !important;
  border-radius: 6px !important;
  padding: 8px 24px !important;
}

.swal-btn-custom:hover {
  background-color: #a83d14 !important;
}

.swal-btn-confirmar {
  color: white !important;
}


</style>

